import React from 'react'
import { Input, Upload, Icon, Modal, message, Carousel } from 'antd'
import { upload_token } from '../../../utils/token'
import NProgress from 'nprogress'

import { fetchIcon, fetchSetIcon } from '../../../api/smallProgramSet'
import ImgCrop from 'antd-img-crop'
import './index.scss'
const { TextArea } = Input
function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = (error) => reject(error)
  })
}

class Zhuanqu_set extends React.Component {
  state = {
    token: upload_token(),
    previewVisible: false,
    previewImage: '',
  }
  handleCancel = () => this.setState({ previewVisible: false })

  handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj)
    }

    this.setState({
      previewImage: file.url || file.preview,
      previewVisible: true,
    })
  }
  handleRemove = () => {}
  handleChange = ({ fileList, file }, label) => {
    if (file.status === 'done') {
      let data = this.props.zhuanquInfo[label]

      data[0].url =
        file.response.key.indexOf('http://qiniu-retail.ieou.com/') != -1
          ? file.response.key
          : 'http://qiniu-retail.ieou.com/' + file.response.key

      const { type, text_name, url } = data[0]
      fetchSetIcon([
        {
          type,
          name: text_name,
          url,
        },
      ]).then((res) => {
        if (res.success) {
          message.success('设置成功')
        }
      })
    }
    this.props.setFileList(fileList, label)
  }
  linkChange = (e, label) => {
    console.log(e.target.value)
    let list = JSON.parse(JSON.stringify(this.props.zhuanquInfo[label]))
    list[0].temp_name = e.target.value
    this.props.setZhuanquInfo(list, label)
  }
  linkBlur = (e, label) => {
    if (!e.target.value) {
      message.error('请输入文案')
      return
    }
    let list = JSON.parse(JSON.stringify(this.props.zhuanquInfo[label]))

    if (e.target.value !== list[0].text_name) {
      list[0].text_name = list[0].temp_name
      const { type, text_name, url } = list[0]
      console.log(
        e.target.value,
        text_name,
        [
          {
            type,
            name: text_name,
            url,
          },
        ][0].name
      )
      fetchSetIcon([
        {
          type,
          name: text_name,
          url,
        },
      ]).then((res) => {
        if (res.success) {
          message.success('设置成功')
          this.props.setZhuanquInfo(list, label)
          // this.getInfo(false)
        }
      })
    }
  }
  render() {
    const { ryIPList, dfmgList, zhuanquInfo } = this.props
    const { previewVisible, previewImage, token } = this.state
    const uploadButton = (
      <div>
        <Icon type='plus' />
        <div className='ant-upload-text'>上传图片</div>
      </div>
    )
    return (
      <div className='card'>
        <div className='top'>品牌专区设置</div>
        <div className='banner_content'>
          <div style={{ borderBottom: '1px solid #e8e8e8' }} className='left'>
            <div className='title'>图标设置</div>
            <div className='tips'>图标仅支持jpg，jpeg，png格式</div>
            <div style={{ marginBottom: 24 }} className='tips'>
              建议图标尺寸比例为1：1
            </div>
            <div style={{ height: 112 }}>
              <ImgCrop rotate>
                <Upload
                  action='https://upload.qiniup.com/'
                  data={{
                    token: token,
                    key: new Date().getTime() + '@image',
                  }}
                  listType='picture-card'
                  fileList={dfmgList}
                  onPreview={this.handlePreview}
                  onChange={(e) => this.handleChange(e, 'dfmgList')}
                  onRemove={this.handleRemove}
                  showUploadList={{
                    showPreviewIcon: true,
                    showDownloadIcon: true,
                    showRemoveIcon: true,
                  }}
                  accept='image/*'>
                  {dfmgList.length > 0 ? null : uploadButton}
                </Upload>
              </ImgCrop>
            </div>
            <div className='bottom_title'> 标题设置</div>
            {zhuanquInfo.dfmgList ? (
              <div className='input_box'>
                <div className='limit'>
                  {zhuanquInfo.dfmgList[0].temp_name.length}/10
                </div>
                <TextArea
                  style={{ margin: '10px 0' }}
                  rows={2}
                  maxLength={10}
                  onChange={(e) => this.linkChange(e, 'dfmgList')}
                  value={zhuanquInfo.dfmgList[0].temp_name}
                  className='link'
                  onBlur={(e) => this.linkBlur(e, 'dfmgList')}></TextArea>
              </div>
            ) : null}
          </div>
          <div style={{ borderBottom: '1px solid #e8e8e8' }} className='right'>
            {zhuanquInfo.dfmgList ? (
              <div className='dfmg_example'>
                <img src={zhuanquInfo.dfmgList[0].url}></img>
                <div className='words'>{zhuanquInfo.dfmgList[0].text_name}</div>
              </div>
            ) : null}
          </div>
        </div>
        <div className='banner_content'>
          <div className='left'>
            <div className='title'>图标设置</div>
            <div className='tips'>图标仅支持jpg，jpeg，png格式</div>
            <div style={{ marginBottom: 24 }} className='tips'>
              建议图标尺寸比例为1：1
            </div>
            <div style={{ height: 112 }}>
              <ImgCrop rotate>
                <Upload
                  action='https://upload.qiniup.com/'
                  data={{
                    token: token,
                    key: new Date().getTime() + '@image',
                  }}
                  listType='picture-card'
                  fileList={ryIPList}
                  onPreview={this.handlePreview}
                  onChange={(e) => this.handleChange(e, 'ryIPList')}
                  onRemove={this.handleRemove}
                  showUploadList={{
                    showPreviewIcon: true,
                    showDownloadIcon: true,
                    showRemoveIcon: true,
                  }}
                  accept='image/*'>
                  {ryIPList.length > 0 ? null : uploadButton}
                </Upload>
              </ImgCrop>
            </div>
            <div className='bottom_title'> 标题设置</div>
            {zhuanquInfo.ryIPList ? (
              <div className='input_box'>
                <div className='limit'>
                  {zhuanquInfo.ryIPList[0].temp_name.length}/10
                </div>
                <TextArea
                  style={{ margin: '10px 0' }}
                  rows={2}
                  maxLength={10}
                  onChange={(e) => this.linkChange(e, 'ryIPList')}
                  value={zhuanquInfo.ryIPList[0].temp_name}
                  className='link'
                  onBlur={(e) => this.linkBlur(e, 'ryIPList')}></TextArea>
              </div>
            ) : null}
          </div>
          <div className='right'>
            {zhuanquInfo.ryIPList ? (
              <div
                style={{
                  background:
                    'linear-gradient(45deg, #FFE9EE 0%, #FEFEFE 100%)',
                }}
                className='dfmg_example'>
                <img src={zhuanquInfo.ryIPList[0].url}></img>
                <div className='words'>{zhuanquInfo.ryIPList[0].text_name}</div>
              </div>
            ) : null}
          </div>
        </div>
        <Modal
          visible={previewVisible}
          footer={null}
          onCancel={this.handleCancel}>
          <img alt='example' style={{ width: '100%' }} src={previewImage} />
        </Modal>
      </div>
    )
  }
}

export default Zhuanqu_set
